"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/sharp-light-svg-icons";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import clsx from "clsx";
import { useState } from "react";

interface SelectProps {
  name: string;
  ariaLabel: string;
  items: { label: string; value: string; selected?: boolean }[];
  classes?: string;
  onSelected: (val: any) => void;
}

const SortCaseControl: React.FC<SelectProps> = ({
  items,
  classes,
  onSelected,
}) => {
  const [selectedItem, setSelectedItem] = useState(items.find(item => item.selected) ?? items[0]);

  const handleSelected = (evt: any) => {
    setSelectedItem(evt);
    onSelected(evt);
  };

  return (
    <Listbox value={selectedItem} onChange={(evt) => handleSelected(evt)}>
      {/* The closed button has no background of its own, so it takes the section's text colour; --sort-text-color is
          for the options on --sort-bg-color (BUG 21713). */}
      <ListboxButton className={clsx(classes, "px-4 py-2")}>
        <div className="flex justify-between gap-1 items-center homepage-text-sm">
          <span className="whitespace-nowrap">
            Sorter efter:{" "}
          </span>
          <span className="whitespace-nowrap">{selectedItem.label}</span>
          <FontAwesomeIcon className="size-5" icon={faChevronDown} />
        </div>
      </ListboxButton>
      <ListboxOptions
        transition
        anchor="bottom"
        className="border shadow-lg bg-[var(--sort-bg-color)]  py-1"
      >
        {items.map((item) => (
          <ListboxOption
            key={item.value}
            value={item}
            className="cursor-pointer homepage-text-sm bg-[var(--sort-bg-color)] hover:bg-[var(--sort-hover-bg-color)] hover:text-[var(--sort-hover-text-color)] text-[var(--sort-text-color)] px-4 py-2 "
          >
            {item.label}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Listbox>
  );
};

export default SortCaseControl;
